
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 6H15V18H2V6ZM22 18L16 14V10L22 6.00001V18Z" fill="currentColor"></path></svg>';export default svg;
    